"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCompareRowType = exports.Nutrient = void 0;
class Nutrient {
}
exports.Nutrient = Nutrient;
var ProductCompareRowType;
(function (ProductCompareRowType) {
    ProductCompareRowType[ProductCompareRowType["image"] = 0] = "image";
    ProductCompareRowType[ProductCompareRowType["productNumber"] = 1] = "productNumber";
    ProductCompareRowType[ProductCompareRowType["productDescription"] = 2] = "productDescription";
    ProductCompareRowType[ProductCompareRowType["brandName"] = 3] = "brandName";
    ProductCompareRowType[ProductCompareRowType["price"] = 4] = "price";
    ProductCompareRowType[ProductCompareRowType["priceCases"] = 5] = "priceCases";
    ProductCompareRowType[ProductCompareRowType["priceEaches"] = 6] = "priceEaches";
    ProductCompareRowType[ProductCompareRowType["packSize"] = 7] = "packSize";
    ProductCompareRowType[ProductCompareRowType["pricePerPortion"] = 8] = "pricePerPortion";
    ProductCompareRowType[ProductCompareRowType["availableInventory"] = 9] = "availableInventory";
    ProductCompareRowType[ProductCompareRowType["availableInventoryCases"] = 10] = "availableInventoryCases";
    ProductCompareRowType[ProductCompareRowType["availableInventoryEaches"] = 11] = "availableInventoryEaches";
    ProductCompareRowType[ProductCompareRowType["productAttributes"] = 12] = "productAttributes";
    ProductCompareRowType[ProductCompareRowType["purchaseHistory"] = 13] = "purchaseHistory";
    ProductCompareRowType[ProductCompareRowType["netWeight"] = 14] = "netWeight";
    ProductCompareRowType[ProductCompareRowType["usfStorage"] = 15] = "usfStorage";
    ProductCompareRowType[ProductCompareRowType["ingredients"] = 16] = "ingredients";
    ProductCompareRowType[ProductCompareRowType["nutritionalFacts"] = 17] = "nutritionalFacts";
    ProductCompareRowType[ProductCompareRowType["servingSize"] = 18] = "servingSize";
    ProductCompareRowType[ProductCompareRowType["servingsPerContainer"] = 19] = "servingsPerContainer";
    ProductCompareRowType[ProductCompareRowType["calories"] = 20] = "calories";
    ProductCompareRowType[ProductCompareRowType["nutrient"] = 21] = "nutrient";
    ProductCompareRowType[ProductCompareRowType["caloriesFromFat"] = 22] = "caloriesFromFat";
})(ProductCompareRowType = exports.ProductCompareRowType || (exports.ProductCompareRowType = {}));
